import { AlertCircle, RotateCw, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMensalidades } from '@/context/MensalidadesContext';

/**
 * Banner vermelho topo da pagina quando o carregamento do .xlsx falhar.
 * Mostra mensagem do erro + botoes "Tentar de novo" e "Fechar".
 *
 * Conectado directamente ao MensalidadesContext — auto-show quando
 * status === 'error', auto-hide ao chamar dismissError ou reload.
 */
export function ErrorBanner() {
  const { state, reload, dismissError } = useMensalidades();
  const { t } = useTranslation();

  if (state.status !== 'error') return null;

  return (
    <div className="aiobi-error-banner" role="alert" aria-live="assertive">
      <AlertCircle size={18} className="aiobi-error-banner__icon" aria-hidden="true" />
      <div className="aiobi-error-banner__content">
        <strong>{t('error.title')}</strong>
        <span>{state.error ?? t('error.unknown')}</span>
      </div>
      <div className="aiobi-error-banner__actions">
        <button
          type="button"
          className="aiobi-error-banner__btn aiobi-error-banner__btn--retry"
          onClick={reload}
          aria-label={t('error.retry')}
        >
          <RotateCw size={14} />
          <span>{t('error.retry')}</span>
        </button>
        <button
          type="button"
          className="aiobi-error-banner__btn aiobi-error-banner__btn--close"
          onClick={dismissError}
          aria-label={t('error.dismiss')}
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
